import { render } from "./protocol_currency.vue?vue&type=template&id=03a6bc8e"
import script from "./protocol_currency.vue?vue&type=script&lang=js"
export * from "./protocol_currency.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/create/blocks/protocol_currency.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03a6bc8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03a6bc8e', __exports__)) {
    console.log('reload')
    api.reload('03a6bc8e', __exports__)
  }
  
  module.hot.accept("./protocol_currency.vue?vue&type=template&id=03a6bc8e", () => {
    console.log('re-render')
    api.rerender('03a6bc8e', render)
  })

}


export default __exports__